module.exports = '3.3.1';



//////////////////
// WEBPACK FOOTER
// ./~/@feathersjs/feathers/lib/version.js
// module id = 37
// module chunks = 0